export default {
  buttons: {
    remove: 'Rimuovi',
  },
  title: 'Codice promo o Gift card',
};
